var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"secondary-button",attrs:{"block":"","elevation":"0"},on:{"click":[function($event){return _vm.$emit('click', $event)},function($event){$event.stopPropagation();return _vm.$emit('click.stop', $event)}]}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }